// AUTO-GENERATED by scripts/inline-css.mjs — do not edit manually.
// Source: src/ui/lock-screen.css
const lockScreenCSS = `/* -------------------------------------------------------------------------
 * AppLock — Default lock screen styles
 *
 * All selectors are prefixed with \`.applock-\` to avoid collisions
 * with the host app's stylesheet.
 *
 * Themeable via CSS custom properties on :root or the overlay element.
 * ----------------------------------------------------------------------- */

:root {
  --applock-bg: rgba(10, 10, 20, 0.92);
  --applock-surface: rgba(255, 255, 255, 0.06);
  --applock-surface-hover: rgba(255, 255, 255, 0.10);
  --applock-border: rgba(255, 255, 255, 0.10);
  --applock-text: #f0f0f5;
  --applock-text-muted: rgba(240, 240, 245, 0.55);
  --applock-accent: #6c8cff;
  --applock-accent-hover: #8aa4ff;
  --applock-error: #ff6b6b;
  --applock-error-bg: rgba(255, 107, 107, 0.12);
  --applock-warning: #ffb347;
  --applock-warning-bg: rgba(255, 179, 71, 0.12);
  --applock-radius: 12px;
  --applock-font: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --applock-transition: 200ms ease;
}

/* ------- Overlay ------- */

.applock-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--applock-bg);
  backdrop-filter: blur(24px) saturate(1.2);
  -webkit-backdrop-filter: blur(24px) saturate(1.2);
  font-family: var(--applock-font);
  color: var(--applock-text);
  animation: applock-fadein 300ms ease;
}

@keyframes applock-fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ------- Card ------- */

.applock-card {
  width: 100%;
  max-width: 380px;
  padding: 2.5rem 2rem 2rem;
  background: var(--applock-surface);
  border: 1px solid var(--applock-border);
  border-radius: var(--applock-radius);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  text-align: center;
}

/* ------- Icon / Header ------- */

.applock-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--applock-surface);
  border: 1px solid var(--applock-border);
  border-radius: 50%;
}

.applock-icon svg {
  width: 28px;
  height: 28px;
  fill: none;
  stroke: var(--applock-accent);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.applock-title {
  margin: 0 0 0.25rem;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.applock-subtitle {
  margin: 0 0 1.5rem;
  font-size: 0.85rem;
  color: var(--applock-text-muted);
  line-height: 1.5;
}

/* ------- Input group ------- */

.applock-input-group {
  position: relative;
  margin-bottom: 0.75rem;
}

.applock-input {
  width: 100%;
  padding: 0.75rem 2.75rem 0.75rem 1rem;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--applock-border);
  border-radius: calc(var(--applock-radius) - 4px);
  color: var(--applock-text);
  font-size: 0.95rem;
  font-family: var(--applock-font);
  outline: none;
  transition: border-color var(--applock-transition);
  box-sizing: border-box;
}

.applock-input::placeholder {
  color: var(--applock-text-muted);
}

.applock-input:focus {
  border-color: var(--applock-accent);
}

.applock-input.applock-input--error {
  border-color: var(--applock-error);
}

/* ------- Toggle visibility button ------- */

.applock-toggle-vis {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  color: var(--applock-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--applock-transition);
}

.applock-toggle-vis:hover {
  color: var(--applock-text);
}

.applock-toggle-vis svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ------- Submit button ------- */

.applock-submit {
  width: 100%;
  padding: 0.75rem;
  margin-top: 0.5rem;
  background: var(--applock-accent);
  color: #fff;
  border: none;
  border-radius: calc(var(--applock-radius) - 4px);
  font-size: 0.95rem;
  font-weight: 500;
  font-family: var(--applock-font);
  cursor: pointer;
  transition: background var(--applock-transition),
              transform var(--applock-transition);
}

.applock-submit:hover {
  background: var(--applock-accent-hover);
}

.applock-submit:active {
  transform: scale(0.98);
}

.applock-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* ------- Feedback ------- */

.applock-feedback {
  min-height: 1.5rem;
  margin-top: 0.75rem;
  font-size: 0.8rem;
  line-height: 1.5;
}

.applock-feedback--error {
  color: var(--applock-error);
}

.applock-feedback--delay {
  color: var(--applock-warning);
}

/* ------- Setup-specific ------- */

.applock-warning-box {
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  background: var(--applock-warning-bg);
  border: 1px solid rgba(255, 179, 71, 0.25);
  border-radius: calc(var(--applock-radius) - 4px);
  text-align: left;
  font-size: 0.8rem;
  line-height: 1.6;
  color: var(--applock-warning);
}

.applock-warning-box strong {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
}

/* ------- Responsive ------- */

@media (max-width: 440px) {
  .applock-card {
    margin: 1rem;
    padding: 2rem 1.25rem 1.5rem;
  }
}
`;
export default lockScreenCSS;
//# sourceMappingURL=lock-screen-css.js.map